import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Loader, PrimaryButton, SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';
import { DeleteModalProps } from './module';

const ConfirmCancelPlan: FC<DeleteModalProps> = ({
  isOpen,
  planName,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen}>
      <>
        {isLoading && <Loader />}
        <StyledModal>
          <CloseIcon onClick={onClose} />
          <h1>
            {t('clinic_billing.confirmDelete.titlePart1')}{' '}
            <span>{planName}</span>?
          </h1>
          <div>
            <p> {t('clinic_billing.confirmDelete.description')}</p>
          </div>
          <section>
            <SecondaryButton type={'button'} onClick={onClose}>
              {t('cancel')}
            </SecondaryButton>
            <PrimaryButton
              type={'button'}
              onClick={onSubmit}
              styleType={'error'}
            >
              {t('clinic_billing.confirmDelete.confirm')}
            </PrimaryButton>
          </section>
        </StyledModal>
      </>
    </Modal>
  );
};

export default ConfirmCancelPlan;
